import { collection, getDocs, query, where } from "firebase/firestore";
import normalizeSiteCodeAcl from "functions/normalizeSiteCodeAcl";

function unique(values) {
  return [...new Set(values.filter((value) => typeof value === "string" && value.trim()))];
}

export default async function resolveSprayOwnerUIDs(db, siteCode, fallbackUIDs = []) {
  const normalizedSiteCode = normalizeSiteCodeAcl(siteCode);
  const rawSiteCode = typeof siteCode === "string" ? siteCode.trim() : "";
  const fallback = unique(fallbackUIDs);

  if (!normalizedSiteCode && !rawSiteCode) return fallback;

  try {
    const orchardRef = collection(db, "Orchards");
    const snapshots = await Promise.all(
      [...new Set([normalizedSiteCode, rawSiteCode].filter(Boolean))].map((code) =>
        getDocs(query(orchardRef, where("siteCode", "==", code)))
      )
    );

    const mappedOwnerUIDs = snapshots.flatMap((snapshot) =>
      snapshot.docs.flatMap((orchardDoc) =>
        Array.isArray(orchardDoc.data().ownerUIDs) ? orchardDoc.data().ownerUIDs : []
      )
    );

    return unique([...mappedOwnerUIDs, ...fallback]);
  } catch (error) {
    console.error("Unable to resolve spray owner UIDs:", error);
    return fallback;
  }
}
